import axios from 'axios'

axios.defaults.retry = 20
axios.defaults.retryDelay = 2000
import { baseApi } from '../../../config/build-config'

var api = ''
if (process.env.NODE_ENV === 'development') {
    api = '/api'
}

if (process.env.NODE_ENV === 'production') {
    api = baseApi
}
console.log('api=' + api)
const service = axios.create({
    baseURL: api,
    timeout: 6000
})

export default service


// WEBPACK FOOTER //
// ./src/utils/http/service.js